import { log } from '../loggers/log';
import { INFO } from '../../constants/LogLevels';

export const performanceObserverCallback: PerformanceObserverCallback = (entries) => {
  entries.getEntries().forEach(logPerformanceEntry);
};

const logPerformanceEntry = (entry: PerformanceEntry) => {
  log(INFO, `Performance metric (name: ${entry.name}, entryType: ${entry.entryType})`, entry.toJSON());
};
